import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';
import { TimelineView, type TimelineItem } from './TimelineView';
import { SupplementEstimateCompare } from './SupplementEstimateCompare';
import { AutoFollowUpCard } from './AutoFollowUpCard';

/** Timeline del PROCESO DE ESTIMACIÓN (pestaña Supplements): First Estimate → sketch →
 *  estimate hecho → Review Estimate → revisión IA → supplement estimate → updates del depto.
 *  Solo estimación; lo de invoice/pagos vive en el timeline de Payments.
 *  El comparativo (primer/último estimado del seguro + cuánto subió) va DE PRIMERO (pedido
 *  2026-07-30) — antes del timeline detallado. */
export function SupplementsTimeline({ claimId }: { claimId: string }) {
  const { t } = useI18n();
  const [items, setItems] = useState<TimelineItem[] | null>(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get<{ items: TimelineItem[] }>(`/api/claims/${claimId}/supplements/timeline`)
      .then((r) => { if (alive) setItems(r.items); })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, [claimId]);

  return (
    <div style={{ display: 'grid', gap: 14 }}>
      <SupplementEstimateCompare claimId={claimId} />
      {/* El auto follow-up al adjuster: en qué va la máquina para este claim, con apagar/pausar/arrancar. */}
      <div className="card" style={{ padding: 10 }}><AutoFollowUpCard claimId={claimId} /></div>
      <TimelineView
        claimId={claimId}
        items={items}
        error={err}
        tPrefix="supTl"
        sendDept="supplements"
        sendRecipients={['homeowner', 'insurance']}
        title={t('supTl.title')}
        subtitle={t('supTl.subtitle')}
        emptyText={t('supTl.empty')}
      />
    </div>
  );
}
